export default {
    YES: 1,
    NO: 0
};
